import { Divider, Grid } from '@mui/material'
import { HearingSummaryProps } from 'components/HearingSummary'
import Label from 'components/Label'
import React from 'react'
import { HearingGeneralDataType } from 'types/hearing-general-data.type'
import { validateField } from 'utils/validate.util'
import { Field } from '../Field'
import dayjs from 'dayjs'
import { cnjMask } from 'utils/mask.util'

export const GeneralDataGroup: React.FC<HearingSummaryProps<HearingGeneralDataType>> = ({
  data,
}) => {
  return (
    <>
      <Label text='DADOS GERAIS' v='h6' bold />
      <Divider />
      {data && data.dataOitiva && (
        <Grid container spacing={1} sx={{ mt: 1 }}>
          <Field label='Promotoria:' text={data.descricaoIdPromotoria} fontWeight={400} />
          <Grid item xs={12}>
            {data.adolescenteApreendido === 'S' ? (
              <Field label='Nº AAAPAI:' text={validateField(data.numeroAaaPai)} fontWeight={400} />
            ) : (
              <Field label='Nº AIAI/BOC:' text={validateField(data.numeroAiai)} fontWeight={400} />
            )}
          </Grid>
          <Field label='Número CNJ:' text={cnjMask(data.numeroCnj)} fontWeight={400} />
          <Field
            label='Data da oitiva:'
            text={
              dayjs(data.dataOitiva).isValid()
                ? dayjs(data.dataOitiva).format('DD/MM/YYYY')
                : data.dataOitiva
            }
            fontWeight={400}
          />
          <Field
            label='Nome do advogado:'
            text={validateField(data.nomeAdvogado)}
            fontWeight={400}
          />
          <Field
            label='Nº da OAB ou matrícula de defensor:'
            text={validateField(data.numeroOabDefensor)}
            fontWeight={400}
          />
          <Field
            label='Nome do responsável pelo adolescente:'
            text={validateField(data.nomeResponsavelAdolescente)}
            fontWeight={400}
          />
        </Grid>
      )}
    </>
  )
}
